export default {
    getDateFromString(dateString) {
        var output = null;
        //-- Parsing manuale di una stringa
        if (typeof dateString === "string" && dateString.length > 18) {
            var year = parseInt(dateString.substring(0, 4));
            var month = parseInt(dateString.substring(5, 7));
            var day = parseInt(dateString.substring(8, 10));
            var hour = parseInt(dateString.substring(11, 13));
            var minute = parseInt(dateString.substring(14, 16));
            var seconds = parseInt(dateString.substring(17, 19));

            if (!isNaN(year) && !isNaN(month) && !isNaN(day) && !isNaN(hour) && !isNaN(minute) && !isNaN(seconds)
                && month > 0 && month < 13) {

                output = new Date();
                output.setYear(year);
                output.setMonth(month - 1);
                output.setDate(day);
                output.setHours(hour);
                output.setMinutes(minute);
                output.setSeconds(seconds);
            }
        }

        return output;
    },

    isValidTaxCode(cf) {
        var validi, i, s, set1, set2, setpari, setdisp;
        if (cf == '') return false;
        cf = cf.toUpperCase();
        if (cf.length != 16)
            return false;
        validi = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        for (i = 0; i < 16; i++) {
            if (validi.indexOf(cf.charAt(i)) == -1)
                return false;
        }
        set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
        setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
        s = 0;
        for (i = 1; i <= 13; i += 2)
            s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
        for (i = 0; i <= 14; i += 2)
            s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
        if (s % 26 != cf.charCodeAt(15) - 'A'.charCodeAt(0))
            return false;

        return true;
    },

    // Validazione partita iva
    isValidVat(pi) {
        var i, s, c, validi;

        if (pi == '') return false;
        if (pi.length != 11) return false;
        validi = "0123456789";
        for (i = 0; i < 11; i++) {
            if (validi.indexOf(pi.charAt(i)) == -1)
                return false;
        }
        s = 0;
        for (i = 0; i <= 9; i += 2)
            s += pi.charCodeAt(i) - '0'.charCodeAt(0);
        console.debug(">>>>", pi, s);
        for (i = 1; i <= 9; i += 2) {
            c = 2 * (pi.charCodeAt(i) - '0'.charCodeAt(0));
            if (c > 9) c = c - 9;
            s += c;
        }
        if ((10 - s % 10) % 10 != pi.charCodeAt(10) - '0'.charCodeAt(0))
            return false;

        return true;
    },

    // carica un'immagine selezionata da un input file e torna una promise
    getPreviewImageFromInput(file) {
        return new Promise(function (resolve, reject) {
            if (file) {
                let reader = new FileReader();
                reader.onload = function (e) {
                    let previewImage = e.target.result;
                    if (previewImage) {
                        resolve(previewImage);
                    } else {
                        reject();
                    }
                };
                reader.readAsDataURL(file);
            } else {
                resolve(null);
            }
        });
    },
}
